var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"share-activity"}},[_c('div',{staticClass:"col-md-12"},[_c('BarChart',{attrs:{"chart-data":_vm.activityDataCollection,"options":_vm.options,"width":1000}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }